import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { DTypeFormDateField } from '@grupo-constant/next-dtype/form';
import { DateFormatStyle, Datepicker, DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { formatISO } from 'date-fns';
import { DateFormat } from '../../dtype-date';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'datepicker-field-component',
    templateUrl: './datepicker-field.component.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useClass: DateFormat },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeDatepickerFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormDateField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    min: Date;
    max: Date;
    remote: boolean;
    style: DateFormatStyle;

    constructor(@Inject(MAT_DATE_FORMATS) private dateFormat: DateFormat) { }

    ngOnInit() {
        this.remote = (this.field.dTypeCol as Datepicker).remote;
        this.style = (this.field.dTypeCol as Datepicker).style;
        if (this.field.min) {
            this.min = new Date(this.field.min);
        }
        if (this.field.max) {
            this.max = new Date(this.field.max);
        }

        this.dateFormat.style = (this.field.dTypeCol as Datepicker).style;

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    dateChange(event: any) {
        this.field.control.setValue(event.value ? formatISO(Date.parse(String(event.value)), { representation: 'date' }) : '');
    }

    openDatepickerOnClick(datepicker: MatDatepicker<Date>) {
        if (!datepicker.opened) {
            datepicker.open();
        }
    }

}
